import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {Share as ShareIcon} from 'react-feather';
import reactStringReplace from 'react-string-replace';

import {CardContainer, Divider, Button} from 'components/common/uiKit';
import {stringFormat} from 'services/converts/strings';

class Ios extends React.Component {


    useWebOnClick = () => {
        const {history} = this.props;
        history.replace({
            pathname: '/app/home'
        });
    };

    render() {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.OS.IOS;

        const AppName = props => <span className='color-primary font-weight-bold'> {pageTranslates.AppName} </span>;

        const More = () => <span className='text-info'> " <i className='fa fa-ellipsis-h'/> More " </span>;
        const OpenInSafari = () => <span className='font-weight-bold'> " Open In Safari " </span>

        if (navigator.userAgent.includes("Instagram")) {
            return (
                <CardContainer>
                    <p className='mb-2'>
                        {reactStringReplace(pageTranslates.Description, '{{0}}', () => <AppName/>)}
                    </p>
                    <Divider color='primary'/>
                    <p className='mb-1'>
                        {reactStringReplace(pageTranslates.Instagram.FirstStep, '{{0}}', () => <More/>)}
                    </p>
                    <p className='mb-1'>
                        {reactStringReplace(pageTranslates.Instagram.SecondStep, '{{0}}', () => <OpenInSafari/>)}
                    </p>
                </CardContainer>
            );
        }

        const Share = () => <span className='text-info'> " <ShareIcon size={16}/> Share " </span>;
        const AddToHome = () => <span className='font-weight-bold'> " <i className='fa fa-plus-square'/> Add to home screen " </span>
        const Add = () => <span className="font-weight-bold"> Add </span>

        return (
            <CardContainer>
                <p className='mb-2'>
                    {reactStringReplace(pageTranslates.Description, '{{0}}', () => <AppName/>)}
                </p>
                <Divider color='primary'/>
                <p className='mb-1'>
                    {reactStringReplace(pageTranslates.FirstStep, '{{0}}', () => <Share/>)}
                </p>
                <p className='mb-1'>
                    {reactStringReplace(pageTranslates.SecondStep, '{{0}}', () => <AddToHome/>)}
                </p>
                <p className='mb-1'>
                    {reactStringReplace(pageTranslates.ThirdStep, '{{0}}', () => <Add/>)}
                </p>
                <Button full onClick={this.useWebOnClick} type='secondary' shadowType='sm'>
                    <span className='font-weight-bold'>
                        {pageTranslates.Web}
                    </span>
                </Button>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Ios));

